import { render, staticRenderFns } from "./QuotationTags.vue?vue&type=template&id=cc12d07a&scoped=true&"
import script from "./QuotationTags.vue?vue&type=script&lang=js&"
export * from "./QuotationTags.vue?vue&type=script&lang=js&"
import style0 from "./QuotationTags.vue?vue&type=style&index=0&id=cc12d07a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc12d07a",
  null
  
)

export default component.exports